/**
 * Where a homepage Trustpilot link points, per reader.
 *
 * Trustpilot publishes the same business profile from a per-language host, and
 * only for the languages it actually serves — `mx.trustpilot.com` 301s to the
 * English `www.`, so Mexican Spanish reads the Spain host like every other
 * Spanish region. Anything unlisted falls back to English rather than guessing
 * a host that would redirect (`invariants.md#rendered-links-are-canonical`).
 */
const PROFILE_HOST_BY_LANGUAGE: Record<string, string> = {
    es: 'es.trustpilot.com',
}

const DEFAULT_PROFILE_HOST = 'www.trustpilot.com'

const PROFILE_PATH = '/review/www.wanderu.com'

export interface TrustpilotProfile {
    url: string
    /** The host of `url` — what an outbound-click event reports as `link_domain`. */
    domain: string
}

/** The Trustpilot reviews page a reader of `locale` should be sent to. */
export function trustpilotProfile(locale: string): TrustpilotProfile {
    const [language] = locale.split('-')
    const domain = PROFILE_HOST_BY_LANGUAGE[language] ?? DEFAULT_PROFILE_HOST

    return { url: `https://${domain}${PROFILE_PATH}`, domain }
}
